import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useUIStore } from '@/shared/stores/uiStore';
import { cn } from '@/shared/lib/utils';
import { BottomNav } from '@/shared/components/BottomNav';
import { Sidebar } from '@/shared/components/Sidebar';
import { Header } from '@/shared/components/Header';

export function AppLayout() {
  const isMobile = useUIStore(state => state.isMobile);
  const isSidebarCollapsed = useUIStore(state => state.isSidebarCollapsed);
  const setIsMobile = useUIStore(state => state.setIsMobile);
  const location = useLocation();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [setIsMobile]);

  return (
    <div className="min-h-screen bg-bg text-text-primary font-body">
      <div className="fixed inset-0 bg-aurora pointer-events-none" />

      <div className="relative z-10 flex min-h-screen">
        <Sidebar />

        <div
          className={cn(
            'flex flex-col flex-1 min-w-0 transition-[margin] duration-300',
            isSidebarCollapsed ? 'lg:ml-20' : 'lg:ml-72'
          )}
        >
          <Header />

          <main className="flex-1 px-4 py-6 pb-28 lg:pb-6 lg:px-8 overflow-x-hidden">
            <AnimatePresence mode="wait">
              <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{ duration: 0.25, ease: 'easeOut' as const }}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </main>

          {isMobile && <BottomNav />}
        </div>
      </div>
    </div>
  );
}
